module.exports = __webpack_public_path__ + "static/media/logo.f055e371.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo.png
// module id = 312
// module chunks = 0